export const iconWhitelist = new Map([
  ['floorDimension', ['fc', 'floor']],
  ['boxingBag', ['fc', 'bag']],
]);
